import { useState } from 'react';
import { toast } from 'react-toastify';
import { downloadReportApi } from '../../api/adminApi';

const REPORTS = [
  {
    type: 'sales',
    title: 'Sales Report',
    desc: 'Daily revenue and order counts for the last 90 days',
    icon: '📈',
    color: '#FEF9C3', fg: '#854D0E',
  },
  {
    type: 'orders',
    title: 'Orders Report',
    desc: 'Full list of all orders with customer and status details',
    icon: '📦',
    color: '#DBEAFE', fg: '#1D4ED8',
  },
  {
    type: 'customers',
    title: 'Customers Report',
    desc: 'All customer accounts with lifetime value and order counts',
    icon: '👥',
    color: '#EDE9FE', fg: '#6D28D9',
  },
  {
    type: 'inventory',
    title: 'Inventory Report',
    desc: 'Current stock levels for all products and SKUs',
    icon: '📋',
    color: '#DCFCE7', fg: '#16A34A',
  },
  {
    type: 'products',
    title: 'Products Report',
    desc: 'Product catalogue with pricing and category info',
    icon: '🏷️',
    color: '#F3F4F6', fg: '#374151',
  },
  {
    type: 'coupons',
    title: 'Coupons Report',
    desc: 'All discount codes with usage counts and expiry dates',
    icon: '🎟️',
    color: '#FEE2E2', fg: '#DC2626',
  },
];

export default function ReportsTab() {
  const [downloading, setDownloading] = useState({});

  const download = async (type) => {
    setDownloading((prev) => ({ ...prev, [type]: true }));
    try {
      const r   = await downloadReportApi(type);
      const url = URL.createObjectURL(r.data);
      const a   = document.createElement('a');
      a.href = url;
      a.download = `bhadralok-${type}-report.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success(`${type} report downloaded`);
    } catch {
      toast.error('Download failed');
    } finally {
      setDownloading((prev) => ({ ...prev, [type]: false }));
    }
  };

  return (
    <div>
      {/* Header */}
      <div style={S.hdr}>
        <div>
          <h1 style={S.title}>Reports</h1>
          <p style={S.sub}>Download store data as CSV files</p>
        </div>
      </div>

      {/* Info banner */}
      <div style={S.infoBanner}>
        <span style={{ fontSize: '16px' }}>📊</span>
        <div>
          <p style={{ fontWeight: 700, margin: 0, fontSize: '13px', color: '#1D4ED8' }}>Download Reports</p>
          <p style={{ margin: 0, fontSize: '12px', color: '#374151' }}>
            All reports are exported in CSV format and include real-time data from your store.
          </p>
        </div>
      </div>

      {/* Report cards grid */}
      <div style={S.grid}>
        {REPORTS.map((r) => (
          <div key={r.type} style={S.card}>
            <div style={{ ...S.iconBox, background: r.color, color: r.fg }}>{r.icon}</div>
            <div style={{ flex: 1 }}>
              <p style={S.cardTitle}>{r.title}</p>
              <p style={S.cardDesc}>{r.desc}</p>
            </div>
            <button
              style={{ ...S.dlBtn, opacity: downloading[r.type] ? .6 : 1 }}
              onClick={() => download(r.type)}
              disabled={downloading[r.type]}
            >
              {downloading[r.type] ? 'Downloading...' : '↓ Download CSV'}
            </button>
          </div>
        ))}
      </div>

      {/* Note */}
      <p style={S.note}>
        * Reports contain all historical data. For date-filtered exports, use the Analytics tab.
      </p>
    </div>
  );
}

const S = {
  hdr:        { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '16px' },
  title:      { fontFamily: 'var(--font-display)', fontSize: '24px', letterSpacing: '1.5px', color: '#111', margin: 0 },
  sub:        { fontSize: '13px', color: '#9CA3AF', marginTop: '2px' },
  infoBanner: { display: 'flex', alignItems: 'flex-start', gap: '12px', background: '#EFF6FF', border: '1px solid #BFDBFE', padding: '14px 18px', marginBottom: '24px' },
  grid:       { display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '16px', marginBottom: '20px' },
  card:       { background: '#fff', border: '1px solid #E5E5E5', padding: '20px', display: 'flex', alignItems: 'flex-start', gap: '16px', boxShadow: '0 1px 3px rgba(0,0,0,.04)' },
  iconBox:    { width: '48px', height: '48px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 },
  cardTitle:  { fontFamily: 'var(--font-display)', fontSize: '14px', letterSpacing: '1px', color: '#111', margin: '0 0 4px 0' },
  cardDesc:   { fontSize: '12px', color: '#6B7280', margin: '0 0 14px 0', lineHeight: 1.5 },
  dlBtn:      { background: '#111', color: '#fff', border: 'none', padding: '8px 16px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, cursor: 'pointer', letterSpacing: '.5px', whiteSpace: 'nowrap', alignSelf: 'center', flexShrink: 0 },
  note:       { fontSize: '11px', color: '#9CA3AF', fontStyle: 'italic' },
};
